// extracted by mini-css-extract-plugin
module.exports = {"image_block":"_103a151b99--image_block--ddp3_"};